import { Controller } from '@hotwired/stimulus';
import { noop } from 'lodash';

const CONVALIDADA = 1;
const APROBADA_ANTERIOR = 8;

/* global $, Mn */
const InputSelectMenu = Mn.View.extend({
  template: noop,
  ui: {
    input: 'input.nota',
    select: 'select.nota',
    inputFake: '.input-fake',
    addonExencion: '.addon-exencion',
    inputTipo: 'input.tipo-puntuacion',
    lista: 'ul',
  },
  events: {
    'click @ui.lista a': 'clickOpcion',
  },
  onRender() {
    this.getUI('inputFake').hide();
    this.getUI('addonExencion').hide();
    this._initial = true;
    this.selectOption(this.getUI('inputTipo').val());
    this._initial = false;
  },
  clickOpcion(e) {
    e.preventDefault();
    const $link = $(e.currentTarget);
    this.selectOption($link.data('value'));
  },
  selectOption(optionValue) {
    if (!this._initial) {
      this._cleanErrors();
    }
    const $link = this.getUI('lista').find(`a[data-value=${optionValue}]`);
    const notaValue = $link.data('nota') || '';
    let $input = this.getUI('input');
    if ($input.length === 0) {
      $input = this.getUI('select');
    }
    const $inputFake = this.getUI('inputFake');
    const $addonExencion = this.getUI('addonExencion');
    if (this._enableInput(optionValue)) {
      $inputFake.hide();
      $input.show().focus();
      if (this._convalidacion(optionValue) || this._aprobadaAnterior(optionValue)) {
        $addonExencion.text($link.text()).show();
      }
    } else {
      $input.hide();
      $inputFake.text($link.text()).show();
      $addonExencion.text('').hide();
    }
    // Si es la selección inicial al cargar, no tocamos el valor
    if (!this._initial) {
      $input.val(notaValue);
      // Lanzamos el change para el autonumeric se entere y actualice el campo oculto
      $input.change();
    }
    this.getUI('inputTipo').val(optionValue);
    this.triggerMethod('option:selected', optionValue, $link);
  },
  // Se puede sobreescribir en los hijos para indicar si la opción seleccionada habilita el input
  _enableInput(optionSelected) {
    const optionSelectedInt = Number.parseInt(optionSelected, 10);
    return this.getUI('lista').find('a:first').data('value') === optionSelectedInt
      || this._convalidacion(optionSelectedInt)
      || this._aprobadaAnterior(optionSelectedInt);
  },
  _convalidacion(option) {
    return Number.parseInt(option, 10) === CONVALIDADA;
  },
  _aprobadaAnterior(option) {
    return Number.parseInt(option, 10) === APROBADA_ANTERIOR;
  },
  _cleanErrors() {
    this.$('.help-block').remove();
    this.$('.form-group').removeClass('has-error');
  },
});

/*
Se trata de un Componente ligado al partial comun/input_select.
Es un input con un selector a la derecha. El input nos permite
introducir el texto que queramos o, si seleccionamos alguna
opción de la lista, nos lo pone y bloquea el input. Se usa en
el historial académico.
*/
export default class extends Controller {
  connect() {
    new InputSelectMenu({ el: this.element }).render();
  }
}
